import {
  calculateTotal,
  PivotAgingPartyWise,
  PivotDataSummary,
} from "../../Utility/utility"
import { useFetchWithBody } from "../../api/reactQueryCustomHooks"
import { ErrorCard, LoadingCard, NextUITable } from "../../components"
import { apiRoute, GetLoginCredentialDb, linksUrl, outTypeEnum } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { CardBody, Card, Chip, Accordion, AccordionItem } from "@heroui/react"
import { useEffect, useMemo, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleDown, faChartPie, faIndianRupeeSign, faListCheck } from "@fortawesome/free-solid-svg-icons"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  SELECTION_MODE,
} from "../../components/NextUITable"
import ApexChart from "../../components/ApexChart"
import { setCurrentParty, setCurrentPartyDaysRange, setIsFromDashboard, setIsFromDashboardReceivable } from "../../state/outstandingReceivableSlice"
import { useNavigate } from "react-router-dom"
import { disableInstantTransitions } from "framer-motion"
import { setIsFromDashboardPayable } from "../../state/outstandingPayableSlice"

export const DashboardReceivable = () => {
  const { compCode ,yearId} = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  let [agingWiseData, setAgingWiseData] = useState([])
  let [selectedFilter, setSelectedFilter] = useState("")
  let [partyWiseAgingWiseData, setPartyWiseAgingData] = useState([])
  const[selectedAge,setSelectedAge]=useState("")
const dispatch=useDispatch();
const navigate=useNavigate();
  const {
    isLoading,
    isError,
    data = [],
  } = useFetchWithBody({
    url: apiRoute.dashboard.getOutstandingData,
    queryKey: "DashboardOutRec",
    inputData: {
      compcode: compCode.join(","),
      action: "Party Aging Summary",
      out_type: outTypeEnum.R,
      party_id: "0",
      //db_user: GetLoginCredentialDb (user,yearId)
    },
  })
  const getAgingData = (data, isPartyWiseAging) => {
    if (data && data?.length > 0)
      setAgingWiseData(PivotDataSummary(data, isPartyWiseAging))
  }
  const totalpartyAgeSummary = useMemo(
    () =>
      calculateTotal({
        data: agingWiseData,
        columnName: "daysRemaning",
      }),
    [agingWiseData]
  )
  const totalBalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "amount",
      }),
    [data]
  )
  const PartyWiseAgingSummary = (data, selectedAge) => {
    setPartyWiseAgingData(PivotAgingPartyWise(data, selectedAge))
  }
  useEffect(() => {
    if(data && data.length>0){
    getAgingData(data, false)
    PartyWiseAgingSummary(data, "all")
    }
  }, [data])

  const handleFilterClose = () => {
    setSelectedFilter("")
    getAgingData(data, false)
    PartyWiseAgingSummary(data, "all")
  }
  const handleSelectionChange = ({ e, column }) => {
    let val = Array.from(e)[0]
    if (column == "party") {
      if (selectedFilter) { getAgingData(data, true); PartyWiseAgingSummary(data, "all") }
      let selectedPartyData = data.filter((ele) => ele.party == val)
      getAgingData(selectedPartyData, true)
      setSelectedFilter(val)
      if(selectedAge && selectedAge!="")
        {
          dispatch(setCurrentParty(selectedPartyData[0]))
          
          dispatch(setIsFromDashboardReceivable(true))
          dispatch(setIsFromDashboardPayable(false))
          dispatch(setCurrentPartyDaysRange({daysRange:selectedAge}))
          navigate(linksUrl.outstanding.receivable.partyDetail)
        }
    }
    if (column == "daysRange") {
      if (selectedFilter) { getAgingData(data, false); PartyWiseAgingSummary(data, "all") }
      let selectedPartydata = data.filter((ele) => ele[val] > 0)
      PartyWiseAgingSummary(selectedPartydata, val)
      setSelectedFilter(val)
      setSelectedAge(val)
    }
  }
  const topActionFilter = []
  let tables = [
    {
      columns: [
        {
          name: "Aging",
          uid: "daysRange",
          secondCol: {
            name: "daysRemaning",
            icon: <FontAwesomeIcon icon={faIndianRupeeSign} size="sm" />,
          },
          footer: {
            type: FOOTER_TYPE.text,
            label: "Total:",
            value: totalpartyAgeSummary,
          },
        },
      ],
      INITIAL_VISIBLE_COLUMNS: ["daysRange"],
      data: agingWiseData,
      id: "daysRange",
    },
    {
      columns: [
        {
          name: "Party Name",
          uid: "party",
          sortable: true,
        },
        {
          name: "Amount",
          uid: "amount",
          type: COLUMN_TYPE.number,
          align: COLUMN_ALIGN_TYPE.center,
          icon: <FontAwesomeIcon icon={faIndianRupeeSign} size="sm" />,
          sortable: true,
          // footer: {
          //   type: FOOTER_TYPE.text,
          //   label: "Total: ",
          //   value: totalBalAmt,
          //   align: COLUMN_ALIGN_TYPE.right
          // },
        },
      ],
      INITIAL_VISIBLE_COLUMNS: ["party", "amount"],
      data: partyWiseAgingWiseData,
      id: "party",
    },
  ]

  if (isError) <ErrorCard />
  if (isLoading) <LoadingCard />
  let labelListAging = useMemo(() => {
    return agingWiseData && agingWiseData?.map(item => item["daysRange"])
  }, [agingWiseData])

  let dataListAging = useMemo(() => {
    return agingWiseData && agingWiseData?.map(item => Number(item["daysRemaning"]))
  }, [agingWiseData])

  return (
    <div>
      {selectedFilter != "" ? (
        <Chip
          color="primary"
          variant="solid"
          size="sm"
          onClose={handleFilterClose}
        >
          {selectedFilter}
        </Chip>
      ) : (
        ""
      )}
      <Accordion selectionMode="multiple" className=" bg-gray-50 " defaultExpandedKeys={["data"]} variant="splitted" isCompact={true}>
      <AccordionItem className=" text-orange-500 uppercase" key="chart"
          startContent={<div className="text-md uppercase align-top">
            <FontAwesomeIcon className="mr-5 text-xl font-bold " icon={faChartPie}></FontAwesomeIcon>
         Receivable Aging Chart</div>}
          indicator={<FontAwesomeIcon className="text-xl text-orange-500" icon={faArrowAltCircleDown}>

          </FontAwesomeIcon>}
          aria-label="" title="">
          <ApexChart labelList={labelListAging} dataList={dataListAging} type={"donut"} legendposition={"left"} showlegend={true} />
        </AccordionItem>
        <AccordionItem key="data" aria-label=""
          className="text-green-700"
          startContent={<div className="text-md uppercase align-middle ">
            <FontAwesomeIcon className="mr-5 text-xl font-bold" icon={faListCheck}></FontAwesomeIcon>
            Receivable Aging Data</div>}
          indicator={<FontAwesomeIcon className="text-xl text-green-500" icon={faArrowAltCircleDown}></FontAwesomeIcon>}
          title="">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            {/* table */}
            {tables.map((table, index) => {
              return (
                <Card key={index}>
                  <CardBody>
                    <NextUITable
                      INITIAL_VISIBLE_COLUMNS={table.INITIAL_VISIBLE_COLUMNS}
                      data={table.data}
                      columns={table.columns}
                      id={table.id}
                      showTopContent={false}
                      topActionFilter={topActionFilter}
                      rowSelection={true}
                      showPagination={false}
                      showFooter={false}
                      selectionMode={SELECTION_MODE.single}
                      handleSelectionChange={handleSelectionChange}
                    />
                  </CardBody>
                </Card>
              )
            })}
          </div>
        </AccordionItem>
       

      </Accordion>

    </div>
  )
}
